"use client";

import { ChakraProvider } from "@chakra-ui/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";
import { system } from "@/lib/theme";
import { Toaster } from "@/components/ui/toaster";
import { PostHogProvider } from "@/lib/analytics";
import { AuthProvider } from "@/lib/auth/auth-provider";
import { CookieConsent } from "@/components/layouts/cookie-consent";

export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000, // 1 minute
            refetchOnWindowFocus: false,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider value={system}>
        <PostHogProvider>
          <AuthProvider>
            {children}
            <Toaster />
            <CookieConsent />
          </AuthProvider>
        </PostHogProvider>
      </ChakraProvider>
    </QueryClientProvider>
  );
}
